const data = ['ilikesk8', 'ilikeskate'];

export default data;
